import { Form } from 'antd';

import { Flex, VFlex } from '@/components/base';
import Input from '@/components/Inputs/Input';
import { ScheduleSelect } from '@/components/ScheduleSelect/ScheduleSelect';
import { Span } from '@/components/Typography';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';
import { SCRAPING_JOB_TYPE } from '../../types';
import { DateRangeField } from './DateRangeField';

export const ScheduleField = (props: { type: SCRAPING_JOB_TYPE }) => {
  const { type } = props;
  return (
    <div>
      <Form.Item
        name={SCRAPER_REQ_FIELD_KEY.SCHEDULE}
        required={true}
        rules={[{ required: true, message: 'Schedule is required' }]}
        hidden
      >
        <input />
      </Form.Item>
      <Form.Item name={SCRAPER_REQ_FIELD_KEY.SHIFT_DAYS} hidden>
        <input />
      </Form.Item>

      <DateRangeField display={type === SCRAPING_JOB_TYPE.ONETIME} required />

      <Form.Item
        label="Schedule"
        layout="vertical"
        required
        labelCol={{ flex: 1 }}
        style={{
          display: type === SCRAPING_JOB_TYPE.SCHEDULED ? 'block' : 'none',
        }}
        shouldUpdate
      >
        {({ getFieldValue, setFieldValue }) => {
          const schedule: Schedule = getFieldValue(
            SCRAPER_REQ_FIELD_KEY.SCHEDULE,
          );
          return (
            <ScheduleSelect
              schedule={schedule}
              setSchedule={(schedule) =>
                setFieldValue(SCRAPER_REQ_FIELD_KEY.SCHEDULE, schedule)
              }
            />
          );
        }}
      </Form.Item>

      <Form.Item
        label="Scraping waiting period"
        layout="vertical"
        tooltip="Skip feedback from the most recent N days in each crawl. These posts will be collected in the next crawl once comments have accumulated."
        labelCol={{ flex: 1 }}
        style={{
          display: type === SCRAPING_JOB_TYPE.SCHEDULED ? 'block' : 'none',
        }}
        shouldUpdate
      >
        {({ getFieldValue, setFieldValue }) => {
          const shiftDays = getFieldValue(SCRAPER_REQ_FIELD_KEY.SHIFT_DAYS);
          return (
            <VFlex g={8}>
              <Flex a="center" g={8}>
                <Input
                  wrapperStyle={{ width: 100 }}
                  style={{ minWidth: 100 }}
                  value={shiftDays}
                  placeholder="0"
                  sizeType="m"
                  onChange={(e) => {
                    setFieldValue(
                      SCRAPER_REQ_FIELD_KEY.SHIFT_DAYS,
                      e.target.value ? Number(e.target.value) : undefined,
                    );
                  }}
                />
                <Span size={2} weight="r" className="text-gray-700">
                  days
                </Span>
              </Flex>
            </VFlex>
          );
        }}
      </Form.Item>
    </div>
  );
};
